export default __webpack_public_path__ + "media/images/carnival/header_1280x840_rj-ccd21733807a88946436a106e748abd8.jpg";